import React, { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { TextProps } from 'react95-native-rabbl/src/components/Typography/Text';
import { withTheme } from 'react95-native-rabbl/src/core/theming';
import * as AppConsts from '@/utilities/AppConsts';

const styles = StyleSheet.create({
  defaultStyle: {
    fontSize: AppConsts.DEFAULT_FONT_SIZE,
    flexShrink: 1,
  },
});

interface Props extends TextProps {
};

export const AppText95 = withTheme(({ style, children, ...props }: PropsWithChildren<Props>) : React.ReactNode => {
  return (
    <Text style={[styles.defaultStyle, style]} {...props}>
      { children }
    </Text>
  );
});
